import { call, put, select, takeEvery } from "redux-saga/effects"

import { genericGetRequest_2, genericPostRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { GET_ADMIN_CAMPAIGN_FULFILLMENT, EXPORT_ADMIN_CAMPAIGN_FULFILLMENT } from "./actionTypes";
import {
  getAdminCampaignFulfillmentError,
  getAdminCampaignFulfillmentSuccess,
  exportAdminCampaignFulfillmentError,
  exportAdminCampaignFulfillmentSuccess,
} from "./actions";
import { buildCampaignFulfillmentCacheKey } from "helpers/campaign_fulfillment_pagination_helper";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";
import { showExportEnqueuedToast } from "helpers/export_toast_helper";

const inFlightAdminCampaignFulfillmentRequests = new Set()

function* OnGetAdminCampaignFulFillment(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const queryParams = action?.payload?.queryParams || action?.payload;
    const useCache = Boolean(action.payload?.useCache)
    const requestedPageNumber = parseInt(queryParams?.page_number, 10) || 1
    const cacheKey = useCache ? buildCampaignFulfillmentCacheKey(queryParams) : null
    const requestKey = `${cacheKey}:${requestedPageNumber}`
    const cachedPage = useCache
      ? yield select((state) => state.AdminCampaignFulFillment.page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    if (useCache && inFlightAdminCampaignFulfillmentRequests.has(requestKey)) {
      return
    }

    if (useCache) {
      inFlightAdminCampaignFulfillmentRequests.add(requestKey)
    }

    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_campaign_fulfillment`,
      queryParams,
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminCampaignFulfillmentSuccess(response, {
      queryParams,
      appendResults: Boolean(action.payload?.appendResults),
      useCache,
    }))
  } catch (error) {
    yield put(getAdminCampaignFulfillmentError(error))
  } finally {
    if (action.payload?.useCache) {
      const queryParams = action?.payload?.queryParams || action?.payload
      const requestedPageNumber = parseInt(queryParams?.page_number, 10) || 1
      const cacheKey = buildCampaignFulfillmentCacheKey(queryParams)
      inFlightAdminCampaignFulfillmentRequests.delete(`${cacheKey}:${requestedPageNumber}`)
    }
  }
}


function* OnExportAdminCampaignFulFillment(action) {
  const user = bsh_getAdminUserDetails();
  const queryParams = action?.payload?.queryParams || action?.payload || {};
  const req = {
    body: JSON.stringify(queryParams),
    headers: {
      Authorization: user.token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_campaign_fulfillment/export`,
      req,
    )
    yield put(exportAdminCampaignFulfillmentSuccess(response))
    showExportEnqueuedToast({ reportExportsAvailable: true })
  } catch (error) {
    yield put(exportAdminCampaignFulfillmentError(error))
    ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: "Failed to queue campaign fulfillment export." })
  }
}


function* AdminCampaignFulFillmentSaga() {
  yield takeEvery(GET_ADMIN_CAMPAIGN_FULFILLMENT, OnGetAdminCampaignFulFillment)
  yield takeEvery(EXPORT_ADMIN_CAMPAIGN_FULFILLMENT, OnExportAdminCampaignFulFillment)

}

export default AdminCampaignFulFillmentSaga;
